var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { id: "scannerEnabled", color: "primary", label: "" },
                model: {
                  value: _vm.scannerEnabled,
                  callback: function ($$v) {
                    _vm.scannerEnabled = $$v
                  },
                  expression: "scannerEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(_vm._s(_vm.$t("admin.analyzer_internal_enable")) + "\n    "),
          _c("br"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  id: "scannerCpeFuzzyEnableInput",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.scannerCpeFuzzyEnableInput,
                  callback: function ($$v) {
                    _vm.scannerCpeFuzzyEnableInput = $$v
                  },
                  expression: "scannerCpeFuzzyEnableInput",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            _vm._s(_vm.$t("admin.analyzer_internal_fuzzy_enable")) + "\n    "
          ),
          _c("br"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  id: "scannerCpeFuzzyExcludePurlInput",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.scannerCpeFuzzyExcludePurlInput,
                  callback: function ($$v) {
                    _vm.scannerCpeFuzzyExcludePurlInput = $$v
                  },
                  expression: "scannerCpeFuzzyExcludePurlInput",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            _vm._s(_vm.$t("admin.analyzer_internal_fuzzy_exclude_purl")) +
              "\n    "
          ),
          _c("br"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  id: "scannerCpeFuzzyExcludeInternalInput",
                  color: "primary",
                  label: "",
                },
                model: {
                  value: _vm.scannerCpeFuzzyExcludeInternalInput,
                  callback: function ($$v) {
                    _vm.scannerCpeFuzzyExcludeInternalInput = $$v
                  },
                  expression: "scannerCpeFuzzyExcludeInternalInput",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            _vm._s(_vm.$t("admin.analyzer_internal_fuzzy_exclude_internal")) +
              "\n    "
          ),
          _c("hr"),
          _vm._v(
            "\n    " + _vm._s(_vm.$t("admin.analyzer_internal_desc")) + "\n  "
          ),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: { variant: "outline-primary" },
              on: { click: _vm.saveChanges },
            },
            [_vm._v(_vm._s(_vm.$t("message.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }